import { registerPlugin } from '@capacitor/core';
import type { IOAuthPlugin } from './definitions';

const OAuthPlugin = registerPlugin<IOAuthPlugin>('OAuthPlugin', {
  web: () => import('./web').then(m => new m.OAuthPlugin()),
});

export * from './definitions';
export { OAuthPlugin };
